module.exports = __webpack_public_path__ + "img/possessif.25506fde.jpg";